module.exports = __webpack_public_path__ + "7b69fc7ef6d4acbe612d709ce01c1c66.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/swimsuit-red-stripe-s.png
// module id = 2013
// module chunks = 0